import { Injectable } from '@angular/core';
import { HttpRequestService } from 'src/app/shared/services/http-request.service';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {

  constructor(private http:HttpRequestService) { }
  addConfigDto(data){
    return this.http.postRequest('Common/addConfigDto',data)
  }
  UpdateConfigDto(data){
    return this.http.postRequest('Common/UpdateConfigDto',data)
  }
  getConfigDto(){
    return this.http.GetRequest('Common/getConfigDto')
  }
}
